module.exports = __webpack_public_path__ + "media/store/images/Rectangle 4-f6803d39b01aeca79404e163ad40e494.png";